import { ViewMode } from '@mobile-mapping/web3d';
import {
  StationNavigationController,
  StationsNavigationCapability,
} from '@trimble/web3d-capabilities';
import { Accessor, createEffect, on } from 'solid-js';

export const useKeyboardStationNavigation = ({
  stationNavigationController,
  viewMode,
  getStationsNavigationCapability,
  isHovered,
  keyDownEvent,
}: {
  stationNavigationController: Accessor<
    StationNavigationController | undefined
  >;
  viewMode: Accessor<ViewMode['type'] | undefined>;
  getStationsNavigationCapability(): Accessor<
    StationsNavigationCapability | undefined
  >;
  isHovered: Accessor<boolean>;
  keyDownEvent: Accessor<KeyboardEvent | null>;
}): void => {
  createEffect(
    on(keyDownEvent, (e) => {
      if (!e || !isHovered()) return;

      const controller = stationNavigationController();
      if (controller?.isEnabled() !== true) return;

      const canNavigate =
        viewMode() === 'Image' ||
        viewMode() === 'Panorama' ||
        getStationsNavigationCapability()()?.selectedStationIndex() != null;
      if (!canNavigate) return;

      if (e.key === 'ArrowLeft' && !controller.isFirstStation()) {
        controller.goToPreviousStation();
        e.preventDefault();
      } else if (e.key === 'ArrowRight' && !controller.isLastStation()) {
        controller.goToNextStation();
        e.preventDefault();
      }
    })
  );
};
